// ═══════════════════════════════════════════════════════════════════
//  modules/chat/ChatAnalysisTab.js
//  ChatAnalysisTab
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { THEME } from "../../socle/theme";
import { CHAT_PROJECT_NAME, SUJ_CANAUX, SUJ_ROLES_RESTREINTS } from "./constantes";
import { SujPanel } from "./SujPanel";

// ═══════════════ ONGLET ANALYSES IA (sous-onglets de canal) ════════════
export function ChatAnalysisTab({ token, user }) {
  const [canal, setCanal] = useState("general");
  const [canaux, setCanaux] = useState([]);
  const etat = (id) => canaux.find((c) => c.id === id);

  // Le Chat Staff n'apparaît que pour les fondateurs et les administrateurs.
  // Le backend refuse de toute façon ?canal=staff aux autres rôles (403) :
  // on évite juste d'afficher un onglet qui rendrait une erreur.
  const voitStaff = SUJ_ROLES_RESTREINTS.includes(user && user.role);
  const canauxVisibles = SUJ_CANAUX.filter((c) => !c.restreint || voitStaff);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div>
        <div style={{ color: THEME.text, fontSize: 17, fontWeight: 800 }}>🤖 Analyses IA</div>
        <div style={{ color: THEME.textMuted, fontSize: 12, marginTop: 3, lineHeight: 1.5 }}>
          Synthèse automatique du chat en jeu <b>et des salons Discord</b> par tranches de 6 h. Bugs, exploits,
          suggestions, plaintes et comportements à surveiller créent une tâche dans le projet « {CHAT_PROJECT_NAME} » ;
          le reste alimente les récaps. Un bug signalé en jeu <i>et</i> sur Discord ne compte que pour un seul sujet.
        </div>
      </div>

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", borderBottom: `1px solid ${THEME.border}`, paddingBottom: 10 }}>
        {canauxVisibles.map((c) => {
          const on = canal === c.id;
          const e = etat(c.id);
          const inactif = e && !e.alimente;
          return (
            <button key={c.id} onClick={() => setCanal(c.id)}
              style={{
                background: on ? THEME.purpleDim : "transparent",
                border: `1px solid ${on ? THEME.purple : THEME.border}`,
                color: on ? THEME.purple : inactif ? THEME.textDim : THEME.textMuted,
                borderRadius: 8, padding: "8px 16px", cursor: "pointer",
                fontSize: 13, fontWeight: on ? 700 : 500, display: "flex", alignItems: "center", gap: 7,
              }}>
              <span style={{ fontSize: 14 }}>{c.icon}</span>{c.label}
              {c.restreint && <span style={{ fontSize: 9, color: THEME.textDim }}>réservé</span>}
              {inactif && <span style={{ fontSize: 9, color: THEME.textDim, border: `1px solid ${THEME.border}`, borderRadius: 5, padding: "1px 5px" }}>{c.attente || "en attente plugin"}</span>}
              {e && e.alimente && <span style={{ fontSize: 10, color: on ? THEME.purple : THEME.textDim }}>{e.nb_messages}</span>}
            </button>
          );
        })}
      </div>

      <SujPanel token={token} user={user} canal={canal} onCanaux={setCanaux} />
    </div>
  );
}
